export default __webpack_public_path__ + "assets/models/e9fc64a9c7fbee21b4e8a1396ca828df.glb";